/* ==========================================================================
   LOVI — LOT 28 B (08/08/2026)  ·  assets/lovi-lot28b.js
   Sans dépendance. Idempotent. Auto-neutralisant : si ni le tiroir ni la
   vidéo ne sont présents, le fichier ne fait rien et ne lève rien.

   1. TIROIR PANIER — marque les lignes CADEAU d'une classe .lovi-l28-gift.
      Tout le rendu est ensuite fait par assets/lovi-lot28b.css (ordre +
      compactage). Aucun nœud n'est déplacé dans le DOM : le tiroir Minimog
      se re-rend intégralement via renderContents(), un déplacement serait à
      refaire à chaque rendu et entrerait en concurrence avec le thème.

   2. VIDÉO MÉCANISME — redémarre à 0 quand la visiteuse arrive dessus.

   HOOKS À NE PAS CASSER, aucun n'est touché ici : data-lovi-cart-upsell,
   data-lovi-cart-upsell-btn, window.__loviCartUpsell, onCartDrawerUpdate,
   renderContents, data-lpdp-pack, data-variant-id, data-gifts.
   ========================================================================== */
(function () {
  'use strict';

  /* ======================================================================
     PARTIE 1 — TIROIR PANIER : marquage des lignes cadeau
     ======================================================================
     Discriminant mesuré sur le DOM rendu (palier 2+2, 3 lignes) :
       ligne cadeau  -> possède .m-cart-item__price--final valant « 0,00 € »
       ligne payante -> ne possède PAS .m-cart-item__price--final du tout
                        (seulement .m-cart-item__price--regular)
     On ne code donc aucun identifiant de variante en dur : un futur cadeau
     hérite du correctif sans modification.
     ====================================================================== */

  var GIFT_CLASS = 'lovi-l28-gift';

  /* Lit un prix affiché en format français et dit s'il vaut zéro.
     « 0,00 € » -> 0        « 1 234,50 € » -> 1234.5
     Les espaces fines et insécables des montants Shopify sont retirées. */
  function isZeroPrice(text) {
    if (!text) return false;
    var raw = String(text)
      .replace(/[\s   ]/g, '')
      .replace(/[^0-9,.\-]/g, '');
    if (!raw) return false;
    /* point = séparateur de milliers quand il est suivi de 3 chiffres */
    raw = raw.replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
    var n = parseFloat(raw);
    return !isNaN(n) && n === 0;
  }

  function isGiftRow(row) {
    var final = row.querySelector('.m-cart-item__price--final');
    if (!final) return false; /* pas de prix final barré => ligne payante */
    return isZeroPrice(final.textContent);
  }

  /* Idempotent : classList.toggle avec un booléen explicite. Rejouer la
     fonction cent fois laisse exactement le même DOM. */
  function tagGiftRows() {
    var rows = document.querySelectorAll('.m-cart-drawer-item');
    if (!rows.length) return;
    Array.prototype.forEach.call(rows, function (row) {
      row.classList.toggle(GIFT_CLASS, isGiftRow(row));
    });
  }

  /* Le tiroir remplace le contenu de <m-cart-drawer-items> à chaque mise à
     jour (ajout, changement de quantité, clic sur le bloc de montée en
     gamme). On réagit aux mutations de structure plutôt que de patcher
     onCartDrawerUpdate : on ne dépend d'aucune API interne du thème, et on
     couvre aussi les rendus déclenchés par un tiers.
     On n'observe QUE childList : poser une classe ne peut donc pas
     re-déclencher l'observateur (pas de boucle). */
  var scheduled = false;
  function scheduleTag() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; tagGiftRows(); };
    /* requestAnimationFrame est le bon moment (avant peinture, donc aucun
       clignotement d'ordre), MAIS il ne se déclenche pas dans un onglet en
       arrière-plan ni dans une frame non rendue — cas mesuré : le marquage
       ne partait jamais. On arme donc AUSSI un setTimeout : le premier des
       deux fait le travail, le second est sans effet (tagGiftRows est
       idempotent). L'appel est lié à window, un rAF détaché lève
       « Illegal invocation » sur WebKit. */
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(run);
    }
    window.setTimeout(run, 0);
  }

  function watchCartDrawer() {
    var drawer = document.getElementById('MinimogCartDrawer');
    if (!drawer) return false;
    if (drawer.__loviL28bWatched) return true; /* idempotence */
    drawer.__loviL28bWatched = true;

    tagGiftRows();

    if (typeof window.MutationObserver === 'function') {
      new MutationObserver(scheduleTag).observe(drawer, {
        childList: true,
        subtree: true
      });
    }
    /* Ceinture et bretelles : au moment où le tiroir s'ouvre. */
    drawer.addEventListener('click', scheduleTag);
    document.addEventListener('cart:updated', scheduleTag);
    document.addEventListener('cart:refresh', scheduleTag);
    return true;
  }

  function initCart() {
    if (watchCartDrawer()) return;
    /* Le tiroir peut être injecté après coup : on attend son arrivée, une
       seule fois, puis on se débranche. */
    if (typeof window.MutationObserver !== 'function') return;
    var boot = new MutationObserver(function () {
      if (watchCartDrawer()) boot.disconnect();
    });
    boot.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { boot.disconnect(); }, 30000);
  }

  /* ======================================================================
     PARTIE 2 — VIDÉO « POURQUOI RIEN N'A MARCHÉ »
     ======================================================================
     Demande Hunt : la vidéo démarre au début quand la visiteuse arrive
     dessus, au lieu de tourner en boucle et de l'obliger à attendre la fin.

     POURQUOI ON N'OBSERVE PAS LA SECTION [id$="__mechanism"] :
     mesuré sur le DOM rendu, la section fait 2831 px de haut en 390 px de
     large. Dans une fenêtre de 844 px le ratio d'intersection ne peut donc
     pas dépasser 844/2831 = 0,298. Un seuil de 0,45 sur la section ne serait
     JAMAIS atteint en mobile : l'observateur ne se déclencherait pas.
     On observe donc la VIDÉO elle-même, qui est aussi la cible sémantique
     correcte (« arriver pile sur la vidéo »), avec un seuil recalculé à
     chaque redimensionnement pour rester atteignable si la vidéo est plus
     haute que la fenêtre.

     POURQUOI « loop » EST RETIRÉ :
     avec un redémarrage à l'entrée, la boucle relancerait la vidéo au milieu
     de la lecture pendant que la visiteuse est encore dans la section — elle
     recréerait exactement le « j'arrive en cours de vidéo » que ce lot doit
     supprimer.

     COHABITATION AVEC assets/lovi-lot18.js (déjà en place) :
     lot18 force video.loop = true et appelle video.play() à l'init, sur
     visibilitychange, et sur un IntersectionObserver à seuil 0,1 — sans
     jamais mettre en pause ni remettre currentTime à 0. Sans précaution il
     rallumerait une vidéo que ce lot vient de mettre en pause volontairement.
     On neutralise ces deux points SANS toucher au fichier lot18 :
       - la propriété IDL « loop » est masquée par un accesseur no-op, donc
         l'affectation de lot18 ne se réfléchit plus sur l'attribut ;
       - « video.play » est encapsulé : tout appel EXTERNE est ignoré quand ce
         contrôleur a décidé que la vidéo doit rester à l'arrêt. Le
         contrôleur, lui, appelle la méthode native.
     ====================================================================== */

  function initVideo() {
    var video = document.querySelector('video.lovi-mech-video') ||
                document.querySelector('[data-lovi-mech-video]');
    if (!video || video.__loviL28b) return;
    video.__loviL28b = true;

    /* --- contraintes iOS : sans muted + playsinline, play() est refusé --- */
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    var nativePlay  = window.HTMLMediaElement.prototype.play.bind(video);
    var nativePause = window.HTMLMediaElement.prototype.pause.bind(video);

    var state = {
      inside: false,        /* la vidéo est-elle actuellement dans le champ */
      userPaused: false,    /* pause déclenchée par la visiteuse */
      selfPausing: false    /* pause déclenchée par ce contrôleur */
    };

    /* --- retrait de la boucle, verrouillé contre lot18 ------------------- */
    video.removeAttribute('loop');
    try {
      Object.defineProperty(video, 'loop', {
        configurable: true,
        enumerable: true,
        get: function () { return false; },
        set: function () { /* lot18 écrit ici : on absorbe sans lever */ }
      });
    } catch (e) {
      /* accesseur refusé : on retire au moins l'attribut à chaque lecture */
      video.addEventListener('play', function () {
        video.removeAttribute('loop');
      });
    }

    /* --- garde-fou sur les play() externes ------------------------------- */
    video.play = function () {
      if (!state.inside || state.userPaused) {
        /* lot18 (ou un tiers) tente de relancer une vidéo hors champ ou
           mise en pause par la visiteuse : on refuse, sans casser le
           contrat de l'API (une promesse résolue est attendue). */
        return window.Promise ? window.Promise.resolve() : undefined;
      }
      return nativePlay();
    };

    /* --- détection d'une pause manuelle ---------------------------------- */
    video.addEventListener('pause', function () {
      if (state.selfPausing) return;      /* pause de sortie de champ */
      if (video.ended) return;            /* fin naturelle, pas une pause */
      if (!state.inside) return;          /* pause hors champ : sans objet */
      state.userPaused = true;
    });
    /* Si la visiteuse relance elle-même, on lui rend la main. */
    video.addEventListener('play', function () {
      if (state.inside) state.userPaused = false;
    });

    /* --- redémarrage à zéro ---------------------------------------------- */
    var waitingMeta = false;
    function rewindAndPlay() {
      if (state.userPaused) return;
      if (video.readyState < 1) {
        /* métadonnées absentes : currentTime n'est pas encore assignable.
           On rejoue l'opération dès qu'elles arrivent, une seule fois.
           Le drapeau évite d'empiler un écouteur par entrée dans le champ. */
        if (!waitingMeta) {
          waitingMeta = true;
          video.addEventListener('loadedmetadata', function once() {
            video.removeEventListener('loadedmetadata', once);
            waitingMeta = false;
            if (state.inside) rewindAndPlay();
          });
        }
        var p0 = nativePlay();
        if (p0 && p0.catch) p0.catch(function () {});
        return;
      }
      try { video.currentTime = 0; } catch (e) { /* source non seekable */ }
      var p = nativePlay();
      if (p && p.catch) p.catch(function () { /* autoplay refusé : poster */ });
    }

    function leave() {
      if (video.paused) return;
      state.selfPausing = true;
      nativePause();
      state.selfPausing = false;
    }

    /* --- observateur, à seuil recalculé ---------------------------------- */
    if (!('IntersectionObserver' in window)) {
      /* Pas d'IO : on garde le comportement historique (lecture continue). */
      var pf = nativePlay(); if (pf && pf.catch) pf.catch(function () {});
      return;
    }

    var observer = null;
    var currentThreshold = -1;
    var firstRun = true;

    function wantedThreshold() {
      var h = video.getBoundingClientRect().height;
      var vh = window.innerHeight || 1;
      if (!h) return 0.45;
      /* ratio maximal réellement atteignable pour CETTE vidéo dans CETTE
         fenêtre ; on vise 80 % de ce maximum, plafonné à 0,45. */
      var reachable = Math.min(1, vh / h);
      return Math.max(0.15, Math.min(0.45, reachable * 0.8));
    }

    function build() {
      var th = wantedThreshold();
      if (Math.abs(th - currentThreshold) < 0.02 && observer) return;
      currentThreshold = th;
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          var nowInside = e.isIntersecting && e.intersectionRatio >= th;
          /* Premier passage : lot18 a déjà lancé la lecture au chargement,
             hors champ. On aligne l'état réel sur l'état voulu, sinon la
             vidéo tourne dans le vide jusqu'à la première sortie de champ. */
          if (firstRun) {
            firstRun = false;
            if (!nowInside && !video.paused) leave();
          }
          if (nowInside && !state.inside) {
            state.inside = true;
            rewindAndPlay();          /* ENTRÉE : on repart de zéro */
          } else if (!nowInside && state.inside) {
            state.inside = false;
            state.userPaused = false; /* la sortie réarme le prochain passage */
            leave();                  /* SORTIE : pause */
          }
          /* déjà dedans et toujours dedans : on ne rejoue pas */
        }
      }, { threshold: [0, th, Math.min(0.99, th + 0.01)] });
      observer.observe(video);
    }

    build();
    video.addEventListener('loadedmetadata', build);
    window.addEventListener('resize', build);
    window.addEventListener('orientationchange', build);

    /* Onglet remis au premier plan : on ne relance que si on est bien dans
       le champ et que la visiteuse n'a pas mis en pause. */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      if (state.inside && !state.userPaused && video.paused) {
        var p = nativePlay(); if (p && p.catch) p.catch(function () {});
      }
    });
  }

  /* ====================================================================== */

  function init() {
    try { initCart(); }  catch (e) { /* le panier ne doit jamais casser la page */ }
    try { initVideo(); } catch (e) { /* la vidéo non plus */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
